import { Tab, Tabs, TabsBody, TabsHeader } from "@material-tailwind/react";
import React, { useEffect, useState } from "react";
import ProfileUpdate from "../../components/Forms/ProfileUpdate";
import ChangePassword from "../../components/Forms/ChangePassword";

export default function Profile() {
    const [activeTab, setActiveTab] = useState<number>(0);

    const handleTabChange = (index: number) => {    
            setActiveTab(index);    
    };

    const chnageTab = (index: number) => {
        setActiveTab(index);
    };

    
    return (
        <>
        <div>
            <h1 className="mb-4 text-3xl text-[#041B44] h-[40px]">Profile</h1>
        </div>
        <div className="bg-white rounded-lg h-[calc(100vh-226px)] w-full overflow-y-scroll scrollbar-hide shadow-md px-2 py-6">
                <Tabs >
                    <TabsHeader className="border-b-2  rounded-none mx-6 ">
                        <Tab
                            key="Basic"
                            value="Basic"
                            onClick={() => handleTabChange(0)}
                            className={`w-48 text-[#B0BEC5] border-b-2 custom-mb-minus-5  ${
                                activeTab === 0 ? "active border-[#0B9ABF]" : ""
                            }  `}
                        >
                            Personal Information
                        </Tab>
                        <Tab
                            key="Sessions"
                            value="Sessions"
                            onClick={() => handleTabChange(1)}
                            className={`w-48 text-[#B0BEC5] border-b-2 custom-mb-minus-5   ${
                                activeTab === 1 ? "active border-[#0B9ABF]" : ""
                            }  `}
                        >
                            Change Password
                        </Tab>
                       
                    </TabsHeader>

                    <TabsBody>

                    <div className={activeTab === 0 ? "tab-panel active" : "tab-panel"}>
                            {activeTab === 0 && (
                                <ProfileUpdate/>
                            )}
                        </div>
                        
                        <div className={activeTab === 1 ? "tab-panel active" : "tab-panel"}>
                        {activeTab === 1 && (
                                <ChangePassword/>
                            )}                            
                        </div>
                    </TabsBody>
                </Tabs>
        </div>
        </>
    );
}